// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"d125f57b","939":"454f3569"}[chunkId] + ".chunk.js";
};